package com.wintermar.inspection.feature.presentation.inspection.complete_answer

actual fun setupContent(onLoad: (fillWidth: Float) -> Unit) {
    onLoad(0.4f)
}
